import {onErrorCaptured, ref} from 'vue';
import {ValidationError} from '@/models';
// import { isArray, isObject, isString } from 'lodash-es';
// import { requiredRule } from '@/utils';

export function useFormValidation(config = {}) {
  const form = ref();

  onErrorCaptured(err => {
    // 吃掉这个异常(会在FormItem上表现出来)
    if (err instanceof ValidationError) return false;
  });

  function validate() {
    form.value.clearValidate();
    return form.value.validate().catch(() => Promise.reject(new ValidationError()));
  }

  function validateFields(names) {
    return form.value.validateFields(names).catch(() => Promise.reject(new ValidationError()));
  }

  // function createRequiredRules(fieldNames = []) {
  //   if (!isArray(fieldNames) && isObject(fieldNames)) {
  //     fieldNames = Object.keys(fieldNames);
  //   }
  //   const rules = computed(() => {
  //     const ret = {};
  //     fieldNames.forEach(name => {
  //       if (isString(name)) {
  //         ret[name] = [requiredRule()];
  //       } else if (isObject(name)) {
  //         const ruleConfig = name;
  //         const rule = requiredRule();
  //         rule.validator = ruleConfig.validator;
  //         ret[ruleConfig.name] = [rule];
  //       } else {
  //         throw 'rule config error';
  //       }
  //     });
  //     return ret;
  //   });
  //
  //   return rules;
  // }

  return {
    form,
    validate,
    validateFields,
  };
}
